export const contactsData = {
  email: "mukhiarambhu@yahoo.in",
  phone: "7276808149",
  address: "Pune,India",
};
